<template>
  <div class="dashboard">
    <h1 class="text-3xl font-bold mb-8 text-primary dark:text-primary-light">Your Tenants</h1>
    <div v-if="tenants.length">
      <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <li v-for="tenant in tenants" :key="tenant.tenant_id" class="card p-6 hover:shadow-lg transition-shadow">
          <a 
            href="#" 
            @click.prevent="selectTenant(tenant.tenant_id)" 
            class="block text-primary dark:text-primary-light hover:text-primary-light dark:hover:text-primary font-medium text-lg transition-colors"
          >
            {{ tenant.friendly_name }}
          </a>
        </li>
      </ul>
    </div>
    <p v-else class="text-xl text-accent dark:text-accent-dark">No tenants available.</p>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'YourTenantsView',
  setup() {
    const store = useStore()
    const router = useRouter()
    const tenants = ref([])

    onMounted(async () => {
      await store.dispatch('fetchTenants')
      tenants.value = store.state.tenants
    })

    const selectTenant = (tenantId) => {
      store.dispatch('setCurrentTenant', tenantId)
      router.push(`/tenants/${tenantId}/documents`)
    }

    return {
      tenants,
      selectTenant
    }
  }
}
</script>